import React, { useState } from "react"

// Libraries
import styled, { css } from "styled-components"
import { Link } from "gatsby"
import PropTypes from "prop-types"

// Components
import Container from "../container"
import MenuToggler from "./ToggleMenu"
import NavigationLinks from "./NavigationLinks"
import SocialLinks from "./SocialLinks"

// Utils
import { colors } from "../../utils/variables"
import breakpoint from "../../utils/breakpoints"

// Icons
import Logo from "../../assets/icons/logo-white.inline.svg"



const StyledMenu = styled.div`
  width: 100%;
  height: 48px;
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => props.$backgroundColor || colors.charcoal};
  z-index: 9000;
  transition: transform 0.6s ease, padding 0.6s ease;
  padding: 40px 0;
  transform: ${(props) => (props.$isScrollingDown ? "translateY(-100%)" : "translateY(0)")};
  ${(props) => props.active && css`transform: translateY(0);`}

  ${breakpoint.medium` height: 80px; padding: 0; `}
  ${breakpoint.large`padding: 0 40px; `}

  ${Container} {
    max-width: 1240px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .logo { margin-right: 20px; }

  .menu {
    max-width: 100%;
    height: ${(props) => (props.active ? "calc(100vh - 50px)" : "0")};
    opacity: ${(props) => (props.active ? "1" : "0")};
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    transition: height 0.6s ease, opacity 0.3s ease;
    overflow-x: hidden;
    overflow-y: scroll;
    background-color: ${colors.charcoal};
    scrollbar-width: none; 
    -ms-overflow-style: none; 
    &::-webkit-scrollbar {
      display: none; 
    }
    
  ${breakpoint.medium`
    height: 80px;
    position: relative;
    flex-direction: row;
    align-items: center;
    justify-content: end;
    flex: 1;
    top: 0;
    padding: 0;
    overflow: visible;
    opacity: 1;
    `}
  }
`;


const Menu = (props) => {
  const { backgroundColor } = props
  const [active, setActive] = useState(false)
  
 
  return (
    <StyledMenu
      active={active}
      backgroundColor={backgroundColor}
    >
      <Container>
        <div className="d-flex align-items-center logo">
          <Link to="/" className="d-flex" title="Logo de Clínica Milito">
            <Logo />
          </Link>
        </div>
        <MenuToggler active={active} toggleMenu={() => setActive(!active)} backgroundColor={backgroundColor} />
        <div className="menu">
          <NavigationLinks backgroundColor={backgroundColor} closeMenu={() => setActive(false)} />
          <SocialLinks backgroundColor={backgroundColor} closeMenu={() => setActive(false)} />
        </div>
      </Container>
    </StyledMenu>
  )
}

Menu.propTypes = {
  backgroundColor: PropTypes.string,
}

Menu.defaultProps = {
  backgroundColor: "salmon",
}
export default Menu
